var render = function render(){
  var _vm$selected, _vm$selected$text, _vm$selected2, _vm$card$skin, _vm$card$skin2, _vm$card$skin3, _vm$selected5, _vm$card$skin4, _vm$card$skin5, _vm$card$skin6, _vm$global$profile, _vm$global$profile2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-editor user-select-none",
    class: {
      'drop-zone-background': _vm.canDrag && _vm.isDragging,
      'preview': _vm.isPreview,
      'disable-zoom': ['edit', 'purcase', 'design'].includes(_vm.mode)
    },
    style: {
      'padding-top': _vm.paddingTop + 'px'
    },
    on: {
      "dragover": function ($event) {
        $event.preventDefault();
        return _vm.registerDrag.apply(null, arguments);
      },
      "touchmove": _vm.onGlobalTouchMove
    }
  }, [(_vm$selected = _vm.selected) !== null && _vm$selected !== void 0 && (_vm$selected$text = _vm$selected.text) !== null && _vm$selected$text !== void 0 && _vm$selected$text.event_link && _vm.card.type == 'INVITATION' ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "300"
    },
    model: {
      value: _vm.showSmartText,
      callback: function ($$v) {
        _vm.showSmartText = $$v;
      },
      expression: "showSmartText"
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Smart text")]), _c('v-card-subtitle', {
    staticClass: "pb-3"
  }, [_vm._v(" This text can auto-format based on your "), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.$emit('step-to', 'event');
      }
    }
  }, [_vm._v("event's " + _vm._s(_vm.eventLinkFieldsReadable)), _c('v-icon', {
    attrs: {
      "x-small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)]), _c('v-list', {
    staticClass: "primary--text",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    staticClass: "simple",
    on: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.updateTextEventLink(false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.selected.text.event_link.disabled ? _vm.mdiRadioboxBlank : _vm.mdiRadioboxMarked)
    }
  }), _c('div', [_vm._v("Auto-format")])], 1), _c('v-list-item', {
    staticClass: "simple",
    on: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.updateTextEventLink(true);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.selected.text.event_link.disabled ? _vm.mdiRadioboxMarked : _vm.mdiRadioboxBlank)
    }
  }), _c('div', [_c('div', [_vm._v("Edit text directly")]), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("If you change your event, make sure you also update this text")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm.card.sample || _vm.card.api == 'TEST' ? _c('div', {
    staticClass: "absolute-fill watermark"
  }) : _vm._e(), !['view', 'preview'].includes(_vm.mode) ? [_c('snackbar', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: _vm.uploadImageStatus.pending || _vm.uploadVideoStatus.pending,
      callback: function ($$v) {
        _vm.$set(_vm.uploadImageStatus.pending || _vm.uploadVideoStatus, "pending", $$v);
      },
      expression: "uploadImageStatus.pending || uploadVideoStatus.pending"
    }
  }, [_c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "width": "2",
      "size": "18",
      "indeterminate": !_vm.transcodeVideoStatus.pending,
      "value": _vm.transcodeVideoStatus.pending ? _vm.transcodeT : null
    }
  }), _vm.transcodeVideoStatus.pending ? _c('span', [_vm._v("Converting file, please wait…")]) : _c('span', [_vm._v("Processing file, please wait…")])], 1), _c('error-dialog', {
    attrs: {
      "status": _vm.uploadImageStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.uploadVideoStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.onDropStatus
    }
  }), _vm.showReplaceDesign ? _c('replace-design-dialog', {
    attrs: {
      "design-id": _vm.card.design_id
    },
    on: {
      "select": function (x) {
        return _vm.$emit('replace-design', x);
      }
    },
    model: {
      value: _vm.showReplaceDesign,
      callback: function ($$v) {
        _vm.showReplaceDesign = $$v;
      },
      expression: "showReplaceDesign"
    }
  }) : _vm._e(), _vm.showEditBtn ? _c('link-btn-dialog', {
    attrs: {
      "btn": _vm.showEditBtn
    },
    on: {
      "input": function (x) {
        if (_vm.selected) Object.assign(_vm.selected.btn, x);else _vm.insertBtn(x);
        _vm.showEditBtn = null;
        _vm.$emit('save');
      },
      "close": function ($event) {
        _vm.showEditBtn = null;
      }
    }
  }) : _vm._e(), _vm.showGiphy ? _c('tenor-dialog', {
    on: {
      "select": _vm.insertFromGiphy
    },
    model: {
      value: _vm.showGiphy,
      callback: function ($$v) {
        _vm.showGiphy = $$v;
      },
      expression: "showGiphy"
    }
  }) : _vm._e(), _vm.showGiftcard ? _c('giftcard-dialog', {
    attrs: {
      "order-id": _vm.orderId,
      "order": _vm.card,
      "selected-page-id": _vm.selectedPage.id,
      "is-completed": _vm.card.state == 'COMPLETED',
      "max-value": _vm.maxGiftcardValue
    },
    on: {
      "select": _vm.insertGiftcard,
      "reload": function ($event) {
        return _vm.$emit('reload');
      }
    },
    model: {
      value: _vm.showGiftcard,
      callback: function ($$v) {
        _vm.showGiftcard = $$v;
      },
      expression: "showGiftcard"
    }
  }) : _vm._e(), _vm.showRecord ? _c('record-video-dialog', {
    attrs: {
      "has-audio": true,
      "max-duration": 60,
      "aspect-ratio": (_vm$selected2 = _vm.selected) !== null && _vm$selected2 !== void 0 && _vm$selected2.mask ? _vm.selected.mask.w / _vm.selected.mask.h : null
    },
    on: {
      "input": _vm.onRecordInput
    }
  }) : _vm._e(), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "upload-image-input",
    attrs: {
      "type": "file",
      "accept": "image/*,image/heic"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "upload-video-input",
    attrs: {
      "type": "file",
      "accept": "video/*,video/3gpp"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  })] : _vm._e(), _vm.contextMenu && _vm.selected && !_vm.isPageReadonly ? _c('v-menu', _vm._b({
    attrs: {
      "offset-y": "",
      "max-width": "320",
      "close-on-content-click": false,
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.contextMenu = null;
      }
    }
  }, 'v-menu', _vm.contextMenu.activator ? {
    'top': true,
    'nudge-left': 80,
    'nudge-top': 2,
    'activator': _vm.contextMenu.activator
  } : {
    'absolute': true,
    'position-x': _vm.contextMenu.x,
    'position-y': _vm.contextMenu.y
  }, false), [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('div', {
    staticClass: "mt-n2 d-flex align-end"
  }, [_c('v-list-item', {
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-list-item-icon', {
    staticClass: "mr-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiSelection)
    }
  })], 1), _c('v-list-item-title', [_vm._v("Deselect")])], 1), _c('card-preview', {
    staticClass: "mt-2 mx-2 v-sheet elevation-1 preview-selected",
    class: {
      'selected-owner': _vm.isPrimary(_vm.selected)
    },
    staticStyle: {
      "width": "48px",
      "background-color": "#FFF8"
    },
    attrs: {
      "mode": _vm.mode,
      "is-card-owner": _vm.isOwner,
      "card": Object.assign({}, _vm.card, {
        background: {},
        pages: [{
          id: 'selected-blob',
          blobs: [_vm.selected]
        }]
      })
    }
  })], 1), _vm.card.user_id == _vm.userId && !_vm.isPrimary(_vm.selected) ? [_c('v-divider', {
    staticClass: "my-2"
  }), _c('div', {
    staticClass: "my-n2 py-2 px-3 text--label-active grey lighten-4"
  }, [_c('div', [_vm._v("Created by")]), _c('div', {
    staticClass: "font-italic",
    staticStyle: {
      "min-height": "15px"
    }
  }, [_vm.loadSelectedSignatureStatus.pending ? [_vm._v("…")] : [_vm._v(_vm._s(_vm._f("email")(_vm.selectedSignature.email)))]], 2)])] : _vm._e(), _c('v-divider', {
    staticClass: "my-2"
  }), _vm.mode == 'design' ? _c('design-blob-list-options', {
    attrs: {
      "blob": _vm.selected,
      "design": _vm.card,
      "can-transform": _vm.canTransformSelected
    },
    on: {
      "set-static-img": function ($event) {
        return _vm.$emit('set-static-img', _vm.selected);
      }
    }
  }) : _vm._e(), _vm.showAutomationOpts && _vm.selected.img ? [_c('v-menu', {
    attrs: {
      "right": "",
      "offset-x": "",
      "max-width": "300"
    },
    on: {
      "input": function (v) {
        if (v) {
          _vm.selectedPersonalizationKey = /^{[^{}]+}$/.test(_vm.selected.img.src) ? _vm.selected.img.src.slice(1, -1).trim() : '';
          _vm.selectedPersonalizationEnabled = !!_vm.selectedPersonalizationKey;
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-list-item', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          attrs: {
            "color": /^{[^{}]+}$/.test(_vm.selected.img.src) ? 'primary' : null,
            "input-value": /^{[^{}]+}$/.test(_vm.selected.img.src)
          }
        }, on), [_c('v-list-item-icon', {
          staticClass: "mr-3"
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiImageMultiple)
          }
        })], 1), _c('v-list-item-title', [_vm._v("Image personalization")]), _c('v-list-item-icon', [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1)], 1)];
      }
    }], null, false, 3104132253)
  }, [_c('div', {
    staticClass: "white pa-3",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-checkbox', {
    staticClass: "pt-0 pb-3",
    attrs: {
      "label": "Enable image personalization",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function (v) {
        if (v) {
          _vm.selectedPersonalizationKey = 'image url';
          _vm.selected.img.src = '{ image url }';
        } else {
          _vm.selected.img.src = '/template-placeholder.png';
        }
      }
    },
    model: {
      value: _vm.selectedPersonalizationEnabled,
      callback: function ($$v) {
        _vm.selectedPersonalizationEnabled = $$v;
      },
      expression: "selectedPersonalizationEnabled"
    }
  }), _c('v-expand-transition', [_vm.selectedPersonalizationEnabled ? _c('v-text-field', {
    staticClass: "ml-8",
    attrs: {
      "label": "Image URL column name",
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "persistent-placeholder": "",
      "error": !_vm.selectedPersonalizationKey || /[{}]/.test(_vm.selectedPersonalizationKey)
    },
    on: {
      "input": function (v) {
        return _vm.selected.img.src = !v || /[{}]/.test(v) ? '/template-placeholder.png' : `{ ${v} }`;
      }
    },
    model: {
      value: _vm.selectedPersonalizationKey,
      callback: function ($$v) {
        _vm.selectedPersonalizationKey = $$v;
      },
      expression: "selectedPersonalizationKey"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "pt-3 text--label-active"
  }, [_vm._v(" Use this option to send a unique image to each recipient of an automation. You'll provide a URL that points to the target image for each recipient in the "), _c('i', [_vm._v("Delivery schedule")]), _vm._v(" step."), _c('br'), _c('br'), _c('v-icon', {
    attrs: {
      "x-small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" Make sure all your images support "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/CORS"
    }
  }, [_vm._v("cross-origin loading")]), _vm._v(" and are the same size so they don't get distorted. ")], 1)], 1)]), _c('v-divider', {
    staticClass: "my-2"
  })] : _vm._e(), _vm._l([[_vm.mdiArrangeBringForward, 'Move forward', function () {
    return _vm.mode != 'design' && !!_vm.selected.template || _vm.selectedI == _vm.selectedPage.blobs.length - 1;
  }, function () {
    return _vm.updateSelectedBlobLayer(1);
  }], [_vm.mdiArrangeSendBackward, 'Move backward', function () {
    return !_vm.selectedI || _vm.mode != 'design' && (!!_vm.selected.template || !!_vm.selectedPage.blobs[_vm.selectedI - 1].template);
  }, function () {
    return _vm.updateSelectedBlobLayer(-1);
  }], [_vm.mdiLayers, 'Show layers', function () {
    return false;
  }, function () {
    return _vm.viewAs = 'layers';
  }], [], [_vm.mdiContentCopy, 'Duplicate', function () {
    var _vm$selected$img;
    return !['TEXT', 'IMG', 'VIDEO'].includes(_vm.selected.type) || _vm.selected.mask && _vm.selected.mask.placeholder == ((_vm$selected$img = _vm.selected.img) === null || _vm$selected$img === void 0 ? void 0 : _vm$selected$img.src) || _vm.selected.type == 'TEXT' && !_vm.selected.text.text;
  }, _vm.duplicateSelectedBlob], [], [_vm.mdiChevronLeft, 'Move to previous page', function () {
    return !!_vm.selected.template || !_vm.selectedPageI || _vm.selected.type == 'TEXT' && !_vm.selected.text.text;
  }, function () {
    return _vm.updateSelectedBlobPage(-1);
  }], _vm.selectedPageI == _vm.card.pages.length - 1 ? [_vm.iconPathChevronRightPlus, 'Move to new page', function () {
    return !!_vm.selected.template || _vm.selected.type == 'TEXT' && !_vm.selected.text.text;
  }, function () {
    return _vm.updateSelectedBlobPage(1);
  }] : [_vm.mdiChevronRight, 'Move to next page', function () {
    return !!_vm.selected.template || _vm.selected.type == 'TEXT' && !_vm.selected.text.text;
  }, function () {
    return _vm.updateSelectedBlobPage(1);
  }], [], _vm.selected.mask ? [_vm.mdiReload, 'Reset', function () {
    var _vm$selected$img2;
    return _vm.selected.mask.placeholder == ((_vm$selected$img2 = _vm.selected.img) === null || _vm$selected$img2 === void 0 ? void 0 : _vm$selected$img2.src);
  }, function () {
    _vm.selected.x = _vm.selected.mask.x;
    _vm.selected.y = _vm.selected.mask.y;
    _vm.selected.w = _vm.selected.mask.w;
    _vm.selected.h = _vm.selected.mask.h;
    _vm.selected.r = _vm.selected.mask.r;
    _vm.selected.img.src = _vm.selected.mask.placeholder;
  }] : [_vm.mdiDelete, 'Delete', function () {
    return _vm.selected.type == 'TEXT' && !_vm.selected.text.text;
  }, function () {
    if (_vm.selected.template) _vm.selected.text.text = '';else _vm.tryDeleteBlob(_vm.selectedPageI, _vm.selectedI);
  }]], function (_ref2) {
    var icon = _ref2[0],
      title = _ref2[1],
      isDisabled = _ref2[2],
      action = _ref2[3];
    return [title ? _c('v-list-item', {
      attrs: {
        "disabled": isDisabled()
      },
      on: {
        "click": action
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    })], 1), _c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(title)
      }
    })], 1) : _c('v-divider', {
      staticClass: "my-2"
    })];
  })], 2)], 1) : _vm._e(), _vm.viewAs == 'grid' ? _c('div', {
    ref: "draggable",
    staticClass: "absolute-fill overflow-auto",
    staticStyle: {
      "padding-bottom": "80px",
      "z-index": "1"
    },
    style: {
      'padding-top': _vm.gridPadding + 'px'
    }
  }, [_c('draggable', {
    staticClass: "ma-0 pa-3",
    staticStyle: {
      "display": "grid",
      "justify-content": "space-between",
      "pointer-events": "auto",
      "width": "100%"
    },
    style: {
      'grid-template-columns': `repeat(auto-fill, ${_vm.$vuetify.breakpoint.xsOnly ? '33%' : 'minmax(200px, 1fr)'})`
    },
    attrs: {
      "draggable": ".draggable",
      "handle": ".page-grid-draggable-handle",
      "ghost-class": "draggable-ghost",
      "disabled": !_vm.isOwner || ['view', 'preview'].includes(_vm.mode),
      "value": _vm.pages,
      "move": function (e) {
        return !e.related.classList.contains('draggable-disabled');
      }
    },
    on: {
      "start": function (e) {
        return _vm.$refs.draggable && _vm.$refs.draggable.classList.add('is-dragging');
      },
      "end": function (e) {
        _vm.$refs.draggable && _vm.$refs.draggable.classList.remove('is-dragging');
        _vm.swapDesignBlobs(_vm.card.pages[e.oldIndex], _vm.card.pages[e.newIndex]);
        if (e.oldIndex == _vm.selectedPageI) _vm.selectedPageI = e.newIndex;
        _vm.$emit('input', _vm.card);
        _vm.$emit('save');
      },
      "input": function (v) {
        return _vm.card.pages = _vm.fixedLastPage ? v.slice(0, -1) : v;
      }
    }
  }, _vm._l(_vm.pages, function (page, i) {
    return _c('div', {
      ref: "grid-page",
      refInFor: true,
      staticClass: "pa-3 relative draggable",
      class: {
        'draggable-disabled': _vm.mode != 'design' && (i <= _vm.lastDesignPageI || _vm.fixedLastPage && i >= _vm.card.pages.length),
        'is-selected-page': i == _vm.selectedPageI
      }
    }, [_vm.mode == 'design' || _vm.isOwner && !['view', 'preview'].includes(_vm.mode) && i > _vm.lastDesignPageI && (!_vm.fixedLastPage || i < _vm.card.pages.length) ? _c('v-btn', {
      staticClass: "absolute page-grid-draggable-handle",
      staticStyle: {
        "bottom": "-8px",
        "left": "calc(50% - 28px)",
        "z-index": "1",
        "cursor": "grab"
      },
      attrs: {
        "fab": "",
        "color": "primary",
        "disabled": _vm.card.pages.length == 1
      }
    }, [_c('v-icon', {
      attrs: {
        "large": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiArrowAll)
      }
    }), _c('span', {
      staticClass: "btn-tooltip top",
      class: {
        persistent: _vm.showHelp && i == _vm.lastDesignPageI + 1
      }
    }, [_vm._v(" Drag to rearrange ")])], 1) : _vm._e(), _c('v-card', {
      staticClass: "overflow-hidden",
      attrs: {
        "hover": "",
        "tile": ""
      },
      on: {
        "click": function ($event) {
          return _vm.closeGrid(i);
        }
      }
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": 5 / 7
      }
    }, [_c('v-lazy', [_c('card-preview', {
      attrs: {
        "card": Object.assign({}, _vm.card, {
          pages: [page]
        }),
        "mode": _vm.mode,
        "is-card-owner": _vm.isOwner
      }
    })], 1)], 1)], 1)], 1);
  }), 0)], 1) : _vm.viewAs == 'layers' ? _c('div', {
    staticClass: "absolute-fill d-flex flex-column justify-center align-center",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('v-spacer'), _c('draggable', {
    staticClass: "fill-width overflow-auto py-3",
    attrs: {
      "draggable": ".draggable",
      "handle": ".layer-draggable-handle",
      "ghost-class": "draggable-ghost",
      "move": function (e) {
        return !e.related.classList.contains('draggable-disabled');
      }
    },
    on: {
      "input": _vm.updateLayers
    },
    model: {
      value: _vm.selectedPageLayers,
      callback: function ($$v) {
        _vm.selectedPageLayers = $$v;
      },
      expression: "selectedPageLayers"
    }
  }, [_vm._l(_vm.selectedPageLayers, function (layer, i) {
    return layer.visible ? _c('div', {
      key: 'layer-' + i,
      staticClass: "draggable d-flex align-center relative px-3",
      class: {
        'draggable-disabled': !layer.rearrange
      },
      staticStyle: {
        "width": "max(50%, 340px)",
        "max-width": "480px",
        "margin": "auto"
      },
      style: {
        'z-index': _vm.selectedPageLayers.length - i
      }
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      staticClass: "btn-group-right layer-draggable-handle",
      attrs: {
        "fab": "",
        "disabled": !layer.rearrange
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(layer.rearrange ? _vm.mdiArrowSplitHorizontal : _vm.mdiLock)
      }
    })], 1), _c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      staticClass: "btn-group-left",
      attrs: {
        "fab": "",
        "disabled": !layer.rearrange || layer.blobs.length != 1
      },
      on: {
        "click": function ($event) {
          _vm.$set(layer.blobs[0], 'opacity', _vm.isTransparent(layer.blobs[0]) ? 1 : 0);
          _vm.$emit('update-blob', _vm.selectedPage.blobs.findIndex(function (x) {
            return x.id == layer.blobs[0].id;
          }), layer.blobs[0]);
          _vm.$emit('input', _vm.card);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": layer.blobs[0] && _vm.isTransparent(layer.blobs[0]) ? 'warning' : null
      },
      domProps: {
        "innerHTML": _vm._s(!layer.blobs[0] || !_vm.isTransparent(layer.blobs[0]) ? _vm.mdiEye : _vm.mdiEyeOff)
      }
    })], 1)], 1), _c('div', {
      staticClass: "flex-grow-1"
    }, [_c('v-card', {
      staticClass: "mx-auto",
      class: {
        'layer-hidden': layer.blobs[0] && _vm.isTransparent(layer.blobs[0])
      },
      staticStyle: {
        "width": "25%",
        "transform": "scale(2.2) rotateX(60deg) skew(-15deg, 0)"
      },
      attrs: {
        "hover": "",
        "tile": "",
        "color": "#FFF8",
        "width": "100%"
      },
      on: {
        "click": function ($event) {
          return _vm.selectLayer(layer);
        }
      }
    }, [_c('card-preview', {
      attrs: {
        "mode": _vm.mode,
        "is-card-owner": _vm.isOwner,
        "card": Object.assign({}, _vm.card, {
          background: i == _vm.selectedPageLayers.length - 1 ? _vm.card.background : {},
          pages: [{
            id: 'page-' + (layer.blobs.length ? layer.blobs[0].id : 'bg-' + i),
            blobs: [].concat(layer.blobs.filter(function (x) {
              return x.mask;
            }).map(function (x) {
              return Object.assign({
                id: x.id + '-mask',
                type: 'IMG'
              }, x.mask, {
                img: {
                  src: '/template-mask-placeholder.png',
                  frame: null
                }
              });
            }), layer.blobs.map(function (x) {
              return Object.assign({}, x, {
                mask: undefined,
                template: undefined,
                opacity: 1
              });
            }))
          }]
        })
      }
    })], 1)], 1)]) : _vm._e();
  }), _c('div', {
    staticStyle: {
      "min-height": "80px"
    }
  })], 2), _c('v-spacer')], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: {
        right: function () {
          return !_vm.isTransformInProgress && !_vm.isZoomed() && _vm.swipe(-1);
        },
        left: function () {
          return !_vm.isTransformInProgress && !_vm.isZoomed() && _vm.swipe(1);
        }
      },
      expression: "{\n      right: () => !isTransformInProgress && !isZoomed() && swipe(-1),\n      left: () => !isTransformInProgress && !isZoomed() && swipe(1)\n    }"
    }],
    ref: "pages-container",
    staticClass: "pa-3 d-flex align-center relative",
    staticStyle: {
      "height": "calc(100% - 68px)"
    },
    on: {
      "!touchstart": function ($event) {
        return _vm.onGestureStart.apply(null, arguments);
      },
      "!touchmove": function ($event) {
        return _vm.onGestureMove.apply(null, arguments);
      },
      "!touchend": function ($event) {
        return _vm.onGestureEnd.apply(null, arguments);
      },
      "contextmenu": function (e) {
        return !e.shiftKey && e.preventDefault();
      }
    }
  }, _vm._l(_vm.pages, function (page, i) {
    return !_vm.viewAs && Math.abs(_vm.selectedPageI - i) < 5 && _vm.hasPageRect && (i == 0 || !_vm.isPreview && !_vm.coverOnly) ? _c('div', {
      key: 'pg-' + i,
      staticClass: "page-transition-container",
      class: {
        transition: !_vm.isPreview && !_vm.disablePageTransition
      },
      style: {
        'left': `calc(50% + ${_vm.getPageOffset(i)}px)`,
        'z-index': _vm.pages.length - Math.abs(i - _vm.selectedPageI),
        'transform': 'scale(' + _vm.getScale(i) + ')',
        'opacity': Math.abs(_vm.selectedPageI - i) >= 4 ? .25 : Math.abs(_vm.selectedPageI - i) == 3 ? .5 : 1
      },
      on: {
        "dragenter": function ($event) {
          return _vm.onDragEnter(i);
        },
        "dragover": function ($event) {
          _vm.dragOverPage = i;
        },
        "drop": function ($event) {
          $event.preventDefault();
          return function (e) {
            return _vm.canDrag && _vm.onDrop(i, e);
          }.apply(null, arguments);
        }
      }
    }, [_vm.selectedPageI == i && _vm.canDrag && _vm.isDragging && !_vm.hasDropZones(page) ? _c('div', {
      staticClass: "d-flex justify-center align-center drop-zone absolute-fill",
      class: {
        'drop-zone-readonly': _vm.isPageReadonly
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "x-large": "",
        "color": _vm.isPageReadonly ? 'warning' : 'white'
      }
    }, [_c('v-icon', {
      attrs: {
        "x-large": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.isPageReadonly ? _vm.mdiUploadOff : _vm.mdiUpload)
      }
    })], 1)], 1) : _vm._e(), _vm.selected && _vm.blobTransformsInProgress[_vm.selected.id] == 'move' && _vm.changeBlobPageD ? [i == _vm.selectedPageI + _vm.changeBlobPageD && (!_vm.fixedLastPage || i < _vm.card.pages.length) ? _c('div', {
      staticClass: "d-flex justify-center align-center drop-zone absolute-fill"
    }) : i == _vm.selectedPageI && _vm.changeBlobPageD == 1 && i == _vm.card.pages.length - 1 ? _c('div', {
      staticClass: "v-tooltip__content tooltip-btn menuable__content__active",
      staticStyle: {
        "z-index": "1",
        "top": "12px",
        "right": "12px"
      }
    }, [_vm._v(" Create new page"), _c('v-icon', {
      staticClass: "ml-1 mr-n1",
      attrs: {
        "color": "white"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.iconPathChevronRightPlus)
      }
    })], 1) : _vm._e()] : _vm._e(), _c('div', {
      ref: _vm.selectedPageI == i ? 'page-container' : null,
      refInFor: true,
      staticClass: "page-container",
      style: {
        transform: 'scale(' + _vm.pageRect.scale + ')',
        width: _vm.pageRect.w + 'px',
        height: _vm.pageRect.h + 'px'
      }
    }, [_c('v-sheet', {
      staticClass: "page-sheet",
      class: {
        'will-hide': _vm.willHide(i),
        wobble: !_vm.didInteract && i == 0 && _vm.selectedPageI == 0 && _vm.pages.length > 1 && _vm.$vuetify.breakpoint.xsOnly && _vm.mode == 'view'
      },
      style: {
        width: _vm.W + 'px',
        height: _vm.H + 'px',
        cursor: !_vm.selected && _vm.selectedPageI == i && !_vm.isPageReadonly ? 'cell' : 'inherit',
        'background-image': _vm.card.background.img ? `url('${_vm.card.background.img}')` : null,
        'background-color': _vm.card.background.color
      },
      attrs: {
        "elevation": "8"
      },
      nativeOn: {
        "click": function ($event) {
          $event.stopPropagation();
          return function (e) {
            return _vm.onPageClick(e, i);
          }.apply(null, arguments);
        }
      }
    }, [_vm.selectedPageI == i && _vm.snapToGuides ? [_vm.guide.horizontal != -1 ? _c('div', {
      staticClass: "absolute fill-width",
      staticStyle: {
        "z-index": "2",
        "border": "1px dashed #1976d288"
      },
      style: {
        top: `min(calc(100% - 2px), ${100 * _vm.guide.horizontal}%)`
      }
    }) : _vm._e(), _vm.guide.vertical != -1 ? _c('div', {
      staticClass: "absolute fill-height",
      staticStyle: {
        "z-index": "2",
        "border": "1px dashed #1976d288"
      },
      style: {
        left: `min(calc(100% - 2px), ${100 * _vm.guide.vertical}%)`
      }
    }) : _vm._e()] : _vm._e(), _vm._l(page.blobs, function (blob, j) {
      var _vm$selected3, _vm$selected4;
      return _vm.isBlobVisible(blob) ? _c('blob', {
        key: blob.id,
        ref: blob.id,
        refInFor: true,
        attrs: {
          "blob": blob,
          "user-id": _vm.userId,
          "skin": _vm.card.skin,
          "is-cropping": _vm.isCropping,
          "is-page-active": _vm.selectedPageI == i && !_vm.isSwiping,
          "is-page-readonly": _vm.isPageReadonly,
          "is-above-selected": j > _vm.selectedI,
          "is-primary": _vm.isPrimary(blob),
          "is-card-owner": _vm.isOwner,
          "is-verified-recipient": _vm.isVerifiedRecipient,
          "mode": _vm.mode,
          "scale": _vm.pageRect.scale,
          "selected": _vm.selected,
          "is-root-transform-in-progress": _vm.isRootTransformInProgress,
          "is-dragging-on-page": _vm.isDragging || (((_vm$selected3 = _vm.selected) === null || _vm$selected3 === void 0 ? void 0 : _vm$selected3.type) == 'IMG' || ((_vm$selected4 = _vm.selected) === null || _vm$selected4 === void 0 ? void 0 : _vm$selected4.type) == 'VIDEO') && _vm.blobTransformsInProgress[_vm.selected.id] == 'move',
          "transform-in-progress": _vm.blobTransformsInProgress[blob.id],
          "snap": _vm.snapToGuides
        },
        on: {
          "update:transform-in-progress": function (v) {
            if (v) _vm.$set(_vm.blobTransformsInProgress, blob.id, v);else _vm.$delete(_vm.blobTransformsInProgress, blob.id);
          },
          "select": function () {
            if (!_vm.gestureStart) _vm.selected = blob;
          },
          "deselect": function ($event) {
            _vm.selected = null;
          },
          "delete": function (immediate) {
            return immediate ? _vm.deleteBlob(i, j) : _vm.tryDeleteBlob(i, j);
          },
          "input": function (x) {
            _vm.fixScroll();
            _vm.$emit('update-blob', i, x);
            _vm.$emit('input', _vm.card);
          },
          "loaded": function ($event) {
            i == 0 ? _vm.loadedCoverBlob(blob.id) : null;
          },
          "prompt-upload": function () {
            if (blob.type == 'IMG') _vm.promptUpload('image', function (f) {
              return _vm.uploadImage('selected-template', f);
            });else _vm.promptUpload('video', function (f) {
              return _vm.uploadVideo('selected-template', f);
            });
          },
          "prompt-record-video": function ($event) {
            _vm.showRecord = true;
          },
          "click-btn": function ($event) {
            return _vm.$emit('click-btn', blob);
          },
          "click-giftcard": function ($event) {
            return _vm.$emit('click-giftcard', blob);
          },
          "click-group-video": function ($event) {
            return _vm.$emit('click-group-video', blob);
          },
          "click-text-event-link": function () {
            _vm.selected = blob;
            if (_vm.card.type == 'INVITATION') _vm.$nextTick(function () {
              return _vm.showSmartText = true;
            });else _vm.updateTextEventLink(true);
          },
          "move-end": _vm.onMoveEnd,
          "play-video": function ($event) {
            return _vm.$emit('play-video');
          },
          "guide": function (axis, pct) {
            return _vm.guide[axis] = pct;
          }
        },
        nativeOn: {
          "contextmenu": function ($event) {
            return function (e) {
              return !e.shiftKey && _vm.selected === blob && _vm.onBlobContextMenu(e);
            }.apply(null, arguments);
          }
        }
      }) : _vm._e();
    })], 2)], 1)], 2) : _vm._e();
  }), 0), !_vm.coverOnly ? _c('div', {
    staticClass: "absolute-fill pa-3",
    style: {
      top: _vm.paddingTop + _vm.gridPadding + 'px'
    }
  }, [!_vm.isPreview ? _c('div', {
    staticClass: "btn-container d-flex flex-column",
    style: {
      'z-index': _vm.pages.length + 1
    }
  }, [_c('div', {
    staticClass: "main-btns flex-grow-1 d-flex",
    class: {
      show: !_vm.viewAs && (_vm.showButtons || _vm.$vuetify.breakpoint.mdAndUp)
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column btn-container-left",
    staticStyle: {
      "width": "64px"
    }
  }, [_vm.selected && (_vm.isPrimary(_vm.selected) || _vm.isOwner) && _vm.selected.type == 'TEXT' ? [!_vm.selected.template || _vm.mode == 'design' ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "fab": "",
      "dark": "",
      "color": "deep-orange lighten-1"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleFitToPage.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.selected.fixed_position ? _vm.iconPathUnfitToPage : _vm.iconPathFitToPage)
    }
  }), _c('span', {
    staticClass: "btn-tooltip right",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v(" " + _vm._s(_vm.selected.fixed_position ? 'Shrink from page' : 'Fit to page') + " ")])], 1) : _vm._e(), _c('font-picker-btn', {
    attrs: {
      "fonts": _vm.fonts,
      "right": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var on = _ref3.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "orange"
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiFormatFont)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Font")])], 1)];
      }
    }], null, false, 2787825601),
    model: {
      value: _vm.selected.text.font,
      callback: function ($$v) {
        _vm.$set(_vm.selected.text, "font", $$v);
      },
      expression: "selected.text.font"
    }
  }), _c('color-picker-btn', {
    attrs: {
      "colors": _vm.colors
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var on = _ref4.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "amber"
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiPalette)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Color")])], 1)];
      }
    }], null, false, 825484043),
    model: {
      value: _vm.selected.text.color,
      callback: function ($$v) {
        _vm.$set(_vm.selected.text, "color", $$v);
      },
      expression: "selected.text.color"
    }
  }), _c('v-menu', {
    attrs: {
      "content-class": "overflow-visible",
      "offset-x": "",
      "nudge-right": "4",
      "min-width": "224"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref5) {
        var on = _ref5.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "purple lighten-3"
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiTextShadow)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Effects")])], 1)];
      }
    }], null, false, 3065523490)
  }, [_c('div', {
    staticClass: "white d-flex flex-wrap btn-group",
    staticStyle: {
      "width": "225px"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, _vm._l(_vm.TEXT_EFFECTS, function (effect, i) {
    return _c('v-btn', {
      key: 'ef-' + effect.name,
      staticClass: "text-effect-btn text-center d-flex flex-column justify-center overflow-hidden",
      attrs: {
        "dark": _vm.isSelectedLightColor,
        "input-value": _vm.isEffectActive(effect)
      },
      on: {
        "click": function ($event) {
          return _vm.toggleEffect(effect);
        }
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "2.5em"
      },
      style: Object.assign({
        color: _vm.selected.text.color
      }, effect.css, effect.cssPreview)
    }, [_vm._v(" Aa ")]), _c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(effect.name))])]);
  }), 1)]), _c('frame-btn', {
    attrs: {
      "options": _vm.selectedOptions,
      "show-background": false
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref6) {
        var on = _ref6.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "brown lighten-1",
            "disabled": !!_vm.selected.fixed_position
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathFrame)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Frame")])], 1)];
      }
    }], null, false, 3756015178)
  }), _c('v-menu', {
    attrs: {
      "content-class": "overflow-visible",
      "offset-x": "",
      "nudge-right": "4",
      "min-width": "200",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref7) {
        var on = _ref7.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "pink lighten-2"
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiFormatAlignTop)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Alignment / sizing")])], 1)];
      }
    }], null, false, 2629955163),
    model: {
      value: _vm.fontAlignmentMenu,
      callback: function ($$v) {
        _vm.fontAlignmentMenu = $$v;
      },
      expression: "fontAlignmentMenu"
    }
  }, [_c('div', {
    staticClass: "white pa-3",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "my-1 relative"
  }, [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Text alignment")]), _c('v-btn', {
    staticClass: "font-align-btn",
    attrs: {
      "small": "",
      "icon": "",
      "color": _vm.selectedOptions.align == 'justify' ? 'primary' : null,
      "input-value": _vm.selectedOptions.align == 'justify'
    },
    on: {
      "click": function ($event) {
        _vm.selectedOptions.align = _vm.selectedOptions.align == 'justify' ? 'center' : 'justify';
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiFormatAlignJustify)
    }
  })], 1)], 1), _c('div', {
    staticClass: "mx-n2",
    staticStyle: {
      "display": "grid",
      "grid-template-columns": "repeat(3, 1fr)"
    }
  }, _vm._l([[-45, 'left', 'start'], [0, 'center', 'start'], [45, 'right', 'start'], [-90, 'left', 'center'], [null, 'center', 'center'], [90, 'right', 'center'], [-135, 'left', 'end'], [180, 'center', 'end'], [135, 'right', 'end']], function (_ref8) {
    var r = _ref8[0],
      align = _ref8[1],
      valign = _ref8[2];
    return _c('div', {
      class: `text-${align}`
    }, [_c('v-btn', {
      staticStyle: {
        "min-width": "unset",
        "padding": "6px"
      },
      attrs: {
        "text": "",
        "rounded": "",
        "color": "primary",
        "disabled": _vm.selectedOptions.align == 'justify' && align != 'center',
        "input-value": (align == _vm.selectedOptions.align || _vm.selectedOptions.align == 'justify' && align == 'center') && valign == _vm.selectedOptions.valign
      },
      on: {
        "click": function ($event) {
          Object.assign(_vm.selectedOptions, {
            align: _vm.selectedOptions.align == 'justify' ? 'justify' : align,
            valign
          });
        }
      }
    }, [align == 'center' && _vm.selectedOptions.align == 'justify' ? _c('v-icon', {
      staticClass: "mx-1",
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiFormatAlignJustify)
      }
    }) : _vm._e(), _c('v-icon', {
      style: {
        transform: `rotate(${r}deg)`
      },
      domProps: {
        "innerHTML": _vm._s(r == null ? _vm.mdiArrowAll : _vm.mdiArrowUpBold)
      }
    })], 1)], 1);
  }), 0), _c('div', {
    staticClass: "mt-6 mb-1 relative"
  }, [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Line height")]), ((_vm.selected.text.css || {})['line-height'] || 1.5) != _vm.selectedTextCSSDefaults['line-height'] ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "font-align-btn",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.$set(_vm.selected.text, 'css', Object.assign({}, _vm.selected.text.css || {}, {
          'line-height': _vm.selectedTextCSSDefaults['line-height']
        }));
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiReload)
    }
  })], 1) : _vm._e()], 1), _c('v-slider', {
    attrs: {
      "hide-details": "",
      "min": "0.8",
      "max": "2.2",
      "step": ".05",
      "value": (_vm.selected.text.css || {})['line-height'] || 1.5
    },
    on: {
      "input": function (v) {
        return _vm.$set(_vm.selected.text, 'css', Object.assign({}, _vm.selected.text.css || {}, {
          'line-height': v
        }));
      }
    }
  }), _c('div', {
    staticClass: "mt-6 mb-1 relative"
  }, [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Letter spacing")]), ((_vm.selected.text.css || {})['letter-spacing'] || '0em') != _vm.selectedTextCSSDefaults['letter-spacing'] ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "font-align-btn",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.$set(_vm.selected.text, 'css', Object.assign({}, _vm.selected.text.css || {}, {
          'letter-spacing': _vm.selectedTextCSSDefaults['letter-spacing']
        }));
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiReload)
    }
  })], 1) : _vm._e()], 1), _c('v-slider', {
    attrs: {
      "hide-details": "",
      "min": "-.1",
      "max": ".2",
      "step": ".01",
      "value": ((_vm.selected.text.css || {})['letter-spacing'] || '0em').slice(0, -2)
    },
    on: {
      "input": function (v) {
        return _vm.$set(_vm.selected.text, 'css', Object.assign({}, _vm.selected.text.css || {}, {
          'letter-spacing': v + 'em'
        }));
      }
    }
  }), _c('div', {
    staticClass: "mt-6 mb-1 relative"
  }, [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Maximum font size")]), _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "font-align-btn",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showFontSizeSlider = !_vm.showFontSizeSlider;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.showFontSizeSlider ? _vm.mdiCounter : _vm.mdiToggleSwitchOff)
    }
  })], 1)], 1), _vm.showFontSizeSlider ? _c('v-slider', {
    attrs: {
      "hide-details": "",
      "min": "0",
      "max": "21.5",
      "step": ".25",
      "value": Math.sqrt(_vm.selected.text.size - 18)
    },
    on: {
      "input": function (v) {
        return _vm.selected.text.size = Math.round(v * v + 18);
      }
    }
  }) : _c('int-field', {
    staticClass: "mt-1",
    attrs: {
      "required": "",
      "min": 18,
      "max": 480
    },
    model: {
      value: _vm.selected.text.size,
      callback: function ($$v) {
        _vm.$set(_vm.selected.text, "size", $$v);
      },
      expression: "selected.text.size"
    }
  })], 1)])] : _vm._e(), _vm.selected && (_vm.isPrimary(_vm.selected) || _vm.isOwner) && ['IMG', 'VIDEO', 'GROUP_VIDEO'].includes(_vm.selected.type) && !_vm.selected.template ? [_c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "fab": "",
      "dark": "",
      "color": "deep-orange lighten-1",
      "disabled": _vm.isCropping
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleFitToPage.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.selected.fixed_position ? _vm.iconPathUnfitToPage : _vm.iconPathFitToPage)
    }
  }), _c('span', {
    staticClass: "btn-tooltip right",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v(" " + _vm._s(_vm.selected.fixed_position ? 'Shrink from page' : 'Fit to page') + " ")])], 1), _vm.selected.type != 'GROUP_VIDEO' ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    class: {
      pulse: _vm.isCropping
    },
    attrs: {
      "fab": "",
      "dark": "",
      "color": "amber accent-4",
      "disabled": _vm.selected.fixed_position
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleCrop.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCrop)
    }
  }), _c('span', {
    staticClass: "btn-tooltip right",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v(" " + _vm._s(_vm.isCropping ? 'Exit crop tool' : 'Crop') + " ")]), _vm.isCropping && !_vm.didHideCropTip ? _c('div', {
    staticClass: "btn-tooltip btn-tooltip-prominent right elevation-20 persistent pa-0",
    staticStyle: {
      "width": "200px",
      "text-wrap": "wrap",
      "z-index": "100"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.didHideCropTip = true;
      }
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_vm._v("Click here when you're finished with the crop tool")]), _c('v-divider'), _c('v-btn', {
    staticClass: "fill-width",
    attrs: {
      "text": "",
      "dark": ""
    }
  }, [_vm._v("Got it")])], 1) : _vm._e()], 1) : _vm._e(), _c('frame-btn', {
    attrs: {
      "options": _vm.selectedOptions,
      "show-background": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref9) {
        var on = _ref9.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "brown lighten-1",
            "disabled": !!_vm.selected.fixed_position || _vm.isCropping
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathFrame)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Frame")])], 1)];
      }
    }], null, false, 1025600654)
  })] : _vm._e(), _vm.selected && (_vm.isPrimary(_vm.selected) || _vm.isOwner) && _vm.selected.type == 'BTN' ? [_c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "fab": "",
      "dark": "",
      "color": "orange darken-2"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function () {
          if (_vm.selected.btn.form) _vm.$emit('click-edit-form');else _vm.showEditBtn = _vm.selected.btn;
        }.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  }), _c('span', {
    staticClass: "btn-tooltip right",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v(" Edit " + _vm._s(_vm.selected.btn.form ? 'event details' : 'link') + " ")])], 1), _c('color-picker-btn', {
    attrs: {
      "colors": [].concat(_vm.colors, ['#0000'])
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref10) {
        var on = _ref10.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "amber"
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiPalette)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Button color")])], 1)];
      }
    }], null, false, 3568321277),
    model: {
      value: _vm.selected.btn.color,
      callback: function ($$v) {
        _vm.$set(_vm.selected.btn, "color", $$v);
      },
      expression: "selected.btn.color"
    }
  }), _c('v-menu', {
    attrs: {
      "offset-x": "",
      "nudge-right": "4",
      "min-width": "224"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref11) {
        var on = _ref11.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "pink lighten-3"
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiFormatSize)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Button size")])], 1)];
      }
    }], null, false, 554741306)
  }, [_c('div', {
    staticClass: "white pa-3",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-slider', {
    attrs: {
      "hide-details": "",
      "min": "1",
      "max": "3",
      "step": ".25",
      "value": _vm.selected.btn.scale || 1
    },
    on: {
      "start": function ($event) {
        _vm.isRootTransformInProgress = true;
      },
      "end": function ($event) {
        _vm.isRootTransformInProgress = false;
      },
      "input": function (v) {
        return _vm.selected.btn.scale = v;
      }
    }
  })], 1)])] : _vm._e(), _vm.selected && (_vm.isPrimary(_vm.selected) || _vm.isOwner) && _vm.selected.type == 'GRADIENT' ? [_c('color-picker-btn', {
    attrs: {
      "colors": ['#FFFFFFFF', '#7F7F7FFF', '#000000FF', '#FFFFFF00', '#7F7F7F00', '#00000000']
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref12) {
        var on = _ref12.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "amber"
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiPalette)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Start color")])], 1)];
      }
    }], null, false, 874483979),
    model: {
      value: _vm.selected.gradient.start,
      callback: function ($$v) {
        _vm.$set(_vm.selected.gradient, "start", $$v);
      },
      expression: "selected.gradient.start"
    }
  }), _c('color-picker-btn', {
    attrs: {
      "colors": ['#FFFFFFFF', '#7F7F7FFF', '#000000FF', '#FFFFFF00', '#7F7F7F00', '#00000000']
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref13) {
        var on = _ref13.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "orange"
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiPalette)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Stop color")])], 1)];
      }
    }], null, false, 1355226),
    model: {
      value: _vm.selected.gradient.stop,
      callback: function ($$v) {
        _vm.$set(_vm.selected.gradient, "stop", $$v);
      },
      expression: "selected.gradient.stop"
    }
  }), _c('v-menu', {
    attrs: {
      "offset-x": "",
      "nudge-right": "4",
      "min-width": "224"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref14) {
        var on = _ref14.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "brown"
          }
        }, on), [_c('v-icon', {
          style: {
            transform: `rotate(${_vm.selected.gradient.r}deg)`
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiArrowUpThin)
          }
        }), _c('span', {
          staticClass: "btn-tooltip right",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Direction")])], 1)];
      }
    }], null, false, 2671543597)
  }, [_c('div', {
    staticClass: "white pa-3",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-slider', {
    attrs: {
      "hide-details": "",
      "min": "0",
      "max": "360",
      "step": _vm.snapToGuides ? 45 : 1
    },
    on: {
      "start": function ($event) {
        _vm.isRootTransformInProgress = true;
      },
      "end": function ($event) {
        _vm.isRootTransformInProgress = false;
      }
    },
    model: {
      value: _vm.selected.gradient.r,
      callback: function ($$v) {
        _vm.$set(_vm.selected.gradient, "r", $$v);
      },
      expression: "selected.gradient.r"
    }
  })], 1)])] : _vm._e()], 2), _c('div', {
    staticClass: "flex-grow-1 d-flex justify-center"
  }), _c('div', {
    staticClass: "d-flex flex-column align-end btn-container-right",
    staticStyle: {
      "width": "64px"
    }
  }, [!_vm.isPageReadonly ? [_vm.mode != 'design' && _vm.allowReplaceDesign ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "fab": "",
      "dark": "",
      "color": "pink darken-1",
      "disabled": _vm.selectedPageI != 0
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.showReplaceDesign = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCards)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v("Change cover")])], 1) : _vm._e(), !((_vm$card$skin = _vm.card.skin) !== null && _vm$card$skin !== void 0 && _vm$card$skin.hide_text_btn) ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "attach": "",
      "fab": "",
      "dark": "",
      "color": "deep-purple",
      "disabled": !!_vm.selected
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.insertText(_vm.W / 2, _vm.H / 4);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTextBox)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left point",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v("Add message")])], 1) : _vm._e(), !((_vm$card$skin2 = _vm.card.skin) !== null && _vm$card$skin2 !== void 0 && _vm$card$skin2.hide_img_btn) ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "attach": "",
      "fab": "",
      "dark": "",
      "color": "indigo",
      "disabled": !!_vm.selected && !(_vm.selected.template && _vm.selected.type == 'IMG' && _vm.mode != 'design')
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.promptUpload('image', _vm.uploadImageFromBtn);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiImage)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v("Add image")])], 1) : _vm._e(), _vm.mode != 'design' && !((_vm$card$skin3 = _vm.card.skin) !== null && _vm$card$skin3 !== void 0 && _vm$card$skin3.hide_video_btn) ? [_vm.isMediaRecorderSupported || _vm.hasGroupVideo || _vm.mode == 'purchase' ? _c('v-menu', {
    attrs: {
      "offset-x": "",
      "left": "",
      "nudge-left": "4"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref15) {
        var on = _ref15.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "blue",
            "disabled": !!_vm.selected && !(_vm.selected.template && _vm.selected.type == 'VIDEO' && _vm.mode != 'design')
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiVideoVintage)
          }
        }), _c('span', {
          staticClass: "btn-tooltip left",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Add video")])], 1)];
      }
    }], null, false, 872432865),
    model: {
      value: _vm.videoMenuOpen,
      callback: function ($$v) {
        _vm.videoMenuOpen = $$v;
      },
      expression: "videoMenuOpen"
    }
  }, [_c('v-list', {
    staticClass: "py-0"
  }, [(_vm.hasGroupVideo || _vm.mode == 'purchase') && !((_vm$selected5 = _vm.selected) !== null && _vm$selected5 !== void 0 && _vm$selected5.template) && !_vm.IS_IFRAME ? [_vm.hasGroupVideo ? _c('v-list-item', {
    on: {
      "click": _vm.addToGroupVideo
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(_vm.mdiAccountGroup))])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add to group video")])], 1)], 1) : _c('v-list-item', {
    on: {
      "click": function ($event) {
        return _vm.$emit('click-add-group-video');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(_vm.mdiAccountGroup))])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add group video…")])], 1)], 1), _c('v-divider')] : _vm._e(), _vm.isMediaRecorderSupported ? [_c('v-list-item', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.promptRecordVideo.apply(null, arguments);
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(_vm.hasGroupVideo ? _vm.mdiAccount : _vm.mdiRecord))])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Record "), _vm.hasGroupVideo ? _c('span', [_vm._v("standalone")]) : _vm._e(), _vm._v(" video…")])], 1)], 1), _c('v-list-item', {
    on: {
      "click": function ($event) {
        _vm.promptUpload('video', function (f) {
          return _vm.uploadVideo('new-blob', f);
        });
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiUpload)
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Upload "), _vm.hasGroupVideo ? _c('span', [_vm._v("standalone")]) : _vm._e(), _vm._v(" video…")])], 1)], 1)] : _c('v-list-item', {
    on: {
      "click": function ($event) {
        _vm.promptUpload('video', function (f) {
          return _vm.uploadVideo('new-blob', f);
        });
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.hasGroupVideo ? _vm.mdiAccount : _vm.mdiUpload)
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add "), _vm.hasGroupVideo ? _c('span', [_vm._v("standalone")]) : _vm._e(), _vm._v(" video")])], 1)], 1)], 2)], 1) : _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "fab": "",
      "dark": "",
      "color": "blue",
      "disabled": !!_vm.selected
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.promptUpload('video', function (f) {
          return _vm.uploadVideo('new-blob', f);
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiVideoVintage)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v("Add video")])], 1)] : _vm._e(), _vm.mode != 'design' && !((_vm$card$skin4 = _vm.card.skin) !== null && _vm$card$skin4 !== void 0 && _vm$card$skin4.hide_gif_btn) ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "fab": "",
      "dark": "",
      "color": "cyan",
      "disabled": !!_vm.selected
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.showGiphy = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiStickerEmoji)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v("Add GIF / sticker")])], 1) : _vm._e(), _vm.mode != 'design' && _vm.maxGiftcardValue && (_vm.isOwner || !((_vm$card$skin5 = _vm.card.skin) !== null && _vm$card$skin5 !== void 0 && _vm$card$skin5.disable_contributor_giftcards)) && _vm.card.type != 'INVITATION' ? [_c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    ref: "add-gift-card-btn",
    staticClass: "btn-top",
    attrs: {
      "fab": "",
      "dark": "",
      "color": "green lighten-2",
      "disabled": !!_vm.selected
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function () {
          if (_vm.showGiftcardBlock) _vm.$confirm({
            title: 'Unsaved changes',
            msg: `Please save your changes before adding ${_vm.giftcardBlobsEditable.length ? 'gift card value' : 'a gift card'}`,
            buttons: ['Ok'],
            primary: 'Ok'
          });else if (_vm.giftcardBlobsEditable.length) _vm.showGiftcardMultipleMenu = true;else _vm.showGiftcard = true;
        }.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v("Add gift card")])], 1), _vm.giftcardBlobsEditable.length && _vm.showGiftcardMultipleMenu ? _c('v-menu', {
    attrs: {
      "offset-x": "",
      "left": "",
      "width": "320",
      "max-width": "320",
      "activator": _vm.$refs['add-gift-card-btn']
    },
    model: {
      value: _vm.showGiftcardMultipleMenu,
      callback: function ($$v) {
        _vm.showGiftcardMultipleMenu = $$v;
      },
      expression: "showGiftcardMultipleMenu"
    }
  }, [_c('v-list', {
    staticClass: "primary--text text-body-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-subtitle', {
    staticClass: "text--label-active px-3 pt-1 pb-2"
  }, [_vm._v(" Add value to existing gift card ")]), _vm._l(_vm.giftcardBlobsEditable, function (g) {
    var _g$giftcard$claim_ids, _g$giftcard$claim_ids2;
    return _c('v-list-item', {
      key: 'add-value-' + g.id,
      staticClass: "li-pop simple px-3",
      on: {
        "click": function ($event) {
          return _vm.$emit('click-giftcard', g);
        }
      }
    }, [_c('v-img', {
      staticClass: "v-card v-sheet mr-0",
      style: {
        opacity: (_g$giftcard$claim_ids = g.giftcard.claim_ids) !== null && _g$giftcard$claim_ids !== void 0 && _g$giftcard$claim_ids.length ? .5 : 1
      },
      attrs: {
        "width": "42",
        "min-width": "42",
        "max-width": "42",
        "aspect-ratio": 300 / 190,
        "src": g.giftcard.product_img
      }
    }), _c('div', {
      staticClass: "pl-0",
      class: {
        'grey--text text--lighten-1': (_g$giftcard$claim_ids2 = g.giftcard.claim_ids) === null || _g$giftcard$claim_ids2 === void 0 ? void 0 : _g$giftcard$claim_ids2.length
      },
      staticStyle: {
        "max-width": "calc(100% - 66px)"
      }
    }, [_c('div', {
      staticClass: "overline short",
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      },
      domProps: {
        "textContent": _vm._s(g.giftcard.product_name)
      }
    }), _c('div', {
      staticClass: "text--label-active",
      staticStyle: {
        "color": "inherit"
      }
    }, [_c('currency', {
      attrs: {
        "code": g.giftcard.cur
      }
    }), _vm._v(_vm._s(g.giftcard.amt) + " ")], 1)]), _c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1);
  }), _c('v-divider', {
    staticClass: "my-2"
  }), _c('v-list-item', {
    staticClass: "li-pop simple px-3 py-4",
    on: {
      "click": function ($event) {
        _vm.showGiftcard = true;
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "padding": "0 9px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  }), _c('div', {
    staticClass: "px-0"
  }, [_vm._v("Add new gift card")]), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 2)], 1) : _vm._e()] : _vm._e(), !((_vm$card$skin6 = _vm.card.skin) !== null && _vm$card$skin6 !== void 0 && _vm$card$skin6.hide_link_btn) ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "fab": "",
      "dark": "",
      "color": "teal",
      "disabled": !!_vm.selected
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.showEditBtn = {
          text: 'Link',
          color: '#1976d2',
          scale: 1.5,
          url: ''
        };
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiLinkVariant)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v("Add link button")])], 1) : _vm._e(), _vm.mode == 'design' ? [_c('v-menu', {
    attrs: {
      "offset-x": "",
      "left": "",
      "nudge-left": "4"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref16) {
        var on = _ref16.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          attrs: {
            "fab": "",
            "dark": "",
            "color": "blue",
            "disabled": !!_vm.selected
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiImageEditOutline)
          }
        }), _c('span', {
          staticClass: "btn-tooltip left",
          class: {
            persistent: _vm.showHelp
          }
        }, [_vm._v("Add slot")])], 1)];
      }
    }], null, false, 1048101196)
  }, [_c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "mb-n1"
  }, [_vm._v("Content type")]), _c('v-list-item', {
    on: {
      "click": _vm.insertTemplateBlob_IMG
    }
  }, [_c('v-list-item-icon', {
    staticClass: "mr-4"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiImage)
    }
  })], 1), _c('v-list-item-title', [_vm._v("Image")])], 1), _c('v-list-item', {
    on: {
      "click": _vm.insertTemplateBlob_VIDEO
    }
  }, [_c('v-list-item-icon', {
    staticClass: "mr-4"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiVideoVintage)
    }
  })], 1), _c('v-list-item-title', [_vm._v("Video")])], 1)], 1)], 1), _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "attach": "",
      "fab": "",
      "dark": "",
      "color": "cyan darken-2",
      "disabled": !!_vm.selected
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.insertGradient.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCircleHalfFull)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v("Add gradient")])], 1), (_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.admin || (_vm$global$profile2 = _vm.global.profile) !== null && _vm$global$profile2 !== void 0 && _vm$global$profile2.designer ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    attrs: {
      "fab": "",
      "dark": "",
      "color": "green"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('toggle-media-library');
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiFolderMultipleImage)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.showHelp
    }
  }, [_vm._v("Toggle media library")])], 1) : _vm._e()] : _vm._e()] : _vm._e()], 2)]), _c('div', {
    staticClass: "flex-grow-1 d-flex justify-center align-end ma-n3 overflow-auto"
  }, [!_vm.isCropping ? _c('div', {
    staticClass: "d-flex pa-3",
    staticStyle: {
      "pointer-events": "auto"
    },
    style: {
      'margin-right': (_vm.ctrlPaddingRight || 0) + 'px'
    }
  }, [_c('v-card', {
    staticClass: "btn-top ma-0 btn-group btn-group-horizontal v-btn--is-elevated",
    staticStyle: {
      "touch-action": "manipulation",
      "border-radius": "28px"
    },
    attrs: {
      "role": "navigation",
      "aria-label": "Card navigation",
      "ripple": false
    },
    on: {
      "click": function () {
        return null;
      }
    }
  }, [_c('v-btn', {
    staticClass: "btn-top ma-0 pl-3 pr-2",
    attrs: {
      "rounded": "",
      "height": "56",
      "elevation": "0",
      "aria-label": "Previous page",
      "disabled": _vm.selectedPageI == 0 || _vm.isCropping
    },
    on: {
      "click": function ($event) {
        return _vm.swipe(-1);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.mode == 'purchase' ? null : 'primary'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  }), _c('span', {
    staticClass: "btn-tooltip top",
    staticStyle: {
      "margin-bottom": "-6px"
    }
  }, [_vm._v("Previous page")])], 1), _vm.isGridAllowed ? _c('v-btn', {
    staticClass: "btn-top ma-0",
    attrs: {
      "height": "56",
      "elevation": "0",
      "disabled": _vm.isSelectedMessageHereText || _vm.isCropping
    },
    on: {
      "click": function (e) {
        return e.target.getElementsByTagName('input')[0].focus();
      }
    }
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    style: {
      width: (_vm.pages.length < 10 ? 36 : _vm.pages.length < 100 ? 52 : 72) + 'px'
    },
    attrs: {
      "hide-details": "",
      "dense": "",
      "autocomplete": "-",
      "type": "tel",
      "aria-label": "Page number",
      "rules": [_vm.isValidPage]
    },
    on: {
      "update:error": function (x) {
        return _vm.pageInputHasError = x;
      },
      "keydown": function ($event) {
        $event.stopPropagation();
      },
      "focus": function (e) {
        return e.target.select();
      },
      "input": _vm.onPageInput
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.pageInput,
      callback: function ($$v) {
        _vm.pageInput = $$v;
      },
      expression: "pageInput"
    }
  }), _c('v-text-field', {
    staticClass: "inline-suffix mt-0",
    attrs: {
      "hide-details": "",
      "dense": "",
      "reverse": "",
      "readonly": "",
      "value": `/ ${_vm.pages.length}`
    }
  })], 1)]), _c('span', {
    staticClass: "btn-tooltip top"
  }, [_vm._v("Jump to page")])]) : _vm._e(), _vm.mode == 'view' ? [_vm.isGridAllowed ? _c('v-btn', {
    staticClass: "btn-top ma-0",
    attrs: {
      "height": "56",
      "elevation": "0",
      "aria-label": _vm.viewAs ? 'Show page stack' : 'Show page grid'
    },
    on: {
      "click": function ($event) {
        _vm.viewAs = _vm.viewAs ? null : 'grid';
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.viewAs ? _vm.iconPathCardPages : _vm.iconPathPageGrid)
    }
  }), _c('span', {
    staticClass: "btn-tooltip top"
  }, [_vm._v(_vm._s(_vm.viewAs ? 'Show page stack' : 'Show page grid'))])], 1) : _vm._e()] : [_c('v-menu', {
    attrs: {
      "top": "",
      "nudge-left": "80",
      "nudge-top": "2",
      "width": "320",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref17) {
        var on = _ref17.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top ma-0",
          attrs: {
            "height": "56",
            "elevation": "0",
            "aria-label": "Page options",
            "disabled": _vm.isSelectedMessageHereText || _vm.isCropping
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathPageSettings)
          }
        }), _c('span', {
          staticClass: "btn-tooltip top"
        }, [_vm._v("Page options")])], 1)];
      }
    }], null, false, 2482753379),
    model: {
      value: _vm.showPageOptions,
      callback: function ($$v) {
        _vm.showPageOptions = $$v;
      },
      expression: "showPageOptions"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('div', {
    staticClass: "text--label-active px-3 pb-1"
  }, [_vm._v("View as")]), _vm._l([[_vm.iconPathCardPages, 'Book', function () {
    return !_vm.viewAs;
  }, function () {
    return _vm.viewAs = null;
  }], [_vm.mdiLayers, 'Layers', function () {
    return _vm.viewAs == 'layers';
  }, function () {
    return _vm.viewAs = 'layers';
  }], [_vm.iconPathPageGrid, 'Grid', function () {
    return _vm.viewAs == 'grid';
  }, function () {
    return _vm.viewAs = 'grid';
  }]], function (_ref18) {
    var icon = _ref18[0],
      title = _ref18[1],
      isSelected = _ref18[2],
      action = _ref18[3];
    return [_c('v-list-item', {
      attrs: {
        "input-value": isSelected(),
        "color": isSelected() ? 'primary' : null
      },
      on: {
        "click": action
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-3"
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    })], 1), _c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(title)
      }
    })], 1)];
  }), _c('v-divider', {
    staticClass: "my-2"
  }), _c('v-menu', {
    attrs: {
      "z-index": "204",
      "right": "",
      "content-class": "page-layout-menu",
      "max-width": "320",
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref19) {
        var on = _ref19.on;
        return [_c('v-list-item', _vm._g({
          attrs: {
            "disabled": _vm.selectedPageI < _vm.lastDesignPageI
          }
        }, on), [_c('v-list-item-icon', {
          staticClass: "mr-3"
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathAddCardPage)
          }
        })], 1), _c('v-list-item-title', [_vm._v("Add page after")]), _c('v-list-item-icon', [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1)], 1)];
      }
    }], null, false, 2574394232),
    model: {
      value: _vm.showAddNewPage,
      callback: function ($$v) {
        _vm.showAddNewPage = $$v;
      },
      expression: "showAddNewPage"
    }
  }, [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('page-layout-picker', {
    attrs: {
      "background": _vm.card.background
    },
    on: {
      "select": function (x) {
        return _vm.addPage(_vm.selectedPageI, x);
      }
    }
  })], 1)]), _c('v-list-item', {
    on: {
      "click": _vm.duplicateCurrentPage
    }
  }, [_c('v-list-item-icon', {
    staticClass: "mr-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathDuplicateCardPage)
    }
  })], 1), _c('v-list-item-title', [_vm._v("Duplicate current page")])], 1), _c('v-list-item', {
    attrs: {
      "disabled": !_vm.canDeleteSelectedPage
    },
    on: {
      "click": function ($event) {
        return _vm.tryDeletePage(_vm.selectedPageI);
      }
    }
  }, [_c('v-list-item-icon', {
    staticClass: "mr-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathDeleteCardPage)
    }
  })], 1), _c('v-list-item-title', [_vm._v("Delete current page")])], 1), _c('v-divider', {
    staticClass: "my-2"
  }), _vm.isOwner ? [_c('v-menu', {
    attrs: {
      "z-index": "204",
      "content-class": "white",
      "right": "",
      "max-width": "320",
      "offset-x": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref20) {
        var on = _ref20.on;
        return [_c('v-list-item', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "py-1",
          attrs: {
            "input-value": _vm.card.background && (_vm.card.background.img || _vm.card.background.color && _vm.card.background.color != '#FFFFFF') ? 'primary' : null,
            "color": _vm.card.background && (_vm.card.background.img || _vm.card.background.color && _vm.card.background.color != '#FFFFFF') ? 'primary' : null
          }
        }, on), [_c('v-list-item-icon', {
          staticClass: "mr-3"
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiTexture)
          }
        })], 1), _c('div', [_c('v-list-item-title', [_vm._v("Background")]), _c('v-list-item-subtitle', {
          staticClass: "grey--text"
        }, [_vm._v("Applies to all pages")])], 1), _c('v-list-item-icon', [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1)], 1)];
      }
    }], null, false, 3988151197)
  }, [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('div', {
    staticClass: "text--label-active px-3 pb-1"
  }, [_vm._v("Custom")]), _c('color-picker-btn', {
    attrs: {
      "colors": _vm.colors,
      "nudge-right": "0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref21) {
        var on = _ref21.on;
        return [_c('v-list-item', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }]
        }, on), [_c('v-btn', {
          attrs: {
            "elevation": "1",
            "fab": "",
            "x-small": "",
            "color": _vm.card.background.color || '#FFFFFF'
          }
        }), _c('v-list-item-title', {
          staticClass: "ml-3"
        }, [_vm._v("Color")]), _c('v-list-item-icon', [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1)], 1)];
      }
    }], null, false, 3099905855),
    model: {
      value: _vm.card.background.color,
      callback: function ($$v) {
        _vm.$set(_vm.card.background, "color", $$v);
      },
      expression: "card.background.color"
    }
  }), _c('texture-menu-btn', {
    attrs: {
      "value": _vm.card.background.img,
      "background-color": _vm.card.background.color || '#FFFFFF'
    },
    on: {
      "input": function (v) {
        return _vm.card.background.img = v;
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref22) {
        var on = _ref22.on;
        return [_c('v-list-item', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }]
        }, on), [_c('v-btn', {
          style: {
            'background-image': _vm.card.background.img ? `url(${_vm.card.background.img})` : null
          },
          attrs: {
            "elevation": "1",
            "fab": "",
            "x-small": "",
            "color": _vm.card.background.color || '#FFFFFF'
          }
        }), _c('v-list-item-title', {
          staticClass: "ml-3"
        }, [_vm._v("Texture / image")]), _c('v-list-item-icon', [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1)], 1)];
      }
    }], null, false, 1467884411)
  })], 1), _c('v-divider'), _c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "text--label-active pb-2"
  }, [_vm._v("Presets")]), _c('v-row', _vm._l([[null, '#FFFFFF']].concat(_vm.BACKGROUNDS), function (_ref23) {
    var src = _ref23[0],
      color = _ref23[1];
    return _c('v-col', {
      key: src,
      attrs: {
        "cols": "4"
      }
    }, [_c('v-card', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      attrs: {
        "tile": "",
        "hover": "",
        "color": color
      },
      on: {
        "click": function ($event) {
          _vm.card.background.img = src;
          _vm.card.background.color = color;
        }
      }
    }, [_c('v-img', {
      attrs: {
        "aspect-ratio": 5 / 7,
        "src": src || '/template-placeholder.png'
      }
    })], 1)], 1);
  }), 1)], 1)], 1)]), _c('v-divider', {
    staticClass: "my-2"
  })] : _vm._e(), _c('v-list-item', {
    attrs: {
      "color": _vm.snapToGuides ? 'primary' : null,
      "input-value": _vm.snapToGuides
    },
    on: {
      "click": function ($event) {
        _vm.alignGuides = !_vm.snapToGuides;
      }
    }
  }, [_c('v-list-item-icon', {
    staticClass: "mr-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiFormatHorizontalAlignCenter)
    }
  })], 1), _c('v-list-item-title', [_vm._v("Snap to guides")]), _c('v-switch', {
    staticClass: "ml-6 mt-n1",
    attrs: {
      "hide-details": "",
      "readonly": "",
      "input-value": _vm.snapToGuides
    }
  })], 1)], 2)], 1), _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    ref: "ctx-menu",
    staticClass: "btn-top ma-0",
    attrs: {
      "height": "56",
      "elevation": "0",
      "aria-label": "Selected options",
      "disabled": !_vm.selected || _vm.isCropping
    },
    on: {
      "click": function (e) {
        return _vm.contextMenu = {
          activator: _vm.$refs['ctx-menu']
        };
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathBlobSettings)
    }
  }), _c('span', {
    staticClass: "btn-tooltip top"
  }, [_vm._v("Selected options")])], 1)], _c('v-menu', {
    attrs: {
      "top": "",
      "nudge-top": "2",
      "max-width": "320",
      "offset-y": "",
      "content-class": "page-layout-menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref24) {
        var on = _ref24.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.selectedPageI == _vm.pages.length - 1 && _vm.mode != 'view',
            expression: "(selectedPageI == pages.length - 1) && (mode != 'view')"
          }, {
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top ma-0 pl-2 pr-3",
          attrs: {
            "rounded": "",
            "height": "56",
            "elevation": "0",
            "aria-label": "Add new page",
            "disabled": _vm.isSelectedMessageHereText || _vm.isCropping || _vm.selectedPageI == _vm.pages.length - 1 && _vm.mode == 'view'
          },
          on: {
            "click": function ($event) {
              return _vm.swipe(1);
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "large": "",
            "color": _vm.mode == 'purchase' ? null : 'primary'
          },
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathChevronRightPlus)
          }
        }), _c('span', {
          staticClass: "btn-tooltip top",
          staticStyle: {
            "margin-bottom": "-6px"
          }
        }, [_vm._v("Add new page")])], 1)];
      }
    }], null, false, 2342867739)
  }, [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('page-layout-picker', {
    attrs: {
      "background": _vm.card.background
    },
    on: {
      "select": function (x) {
        return _vm.addPage(_vm.selectedPageI, x);
      }
    }
  })], 1)]), !(_vm.selectedPageI == _vm.pages.length - 1 && _vm.mode != 'view') ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top ma-0 pl-2 pr-3",
    class: {
      wobble: !_vm.didInteract && _vm.selectedPageI == 0 && _vm.pages.length > 1 && _vm.$vuetify.breakpoint.xsOnly && _vm.mode == 'view'
    },
    attrs: {
      "rounded": "",
      "height": "56",
      "elevation": "0",
      "aria-label": "Next page",
      "disabled": _vm.isSelectedMessageHereText || _vm.isCropping || _vm.selectedPageI == _vm.pages.length - 1
    },
    on: {
      "click": function ($event) {
        return _vm.swipe(1);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.mode == 'purchase' ? null : 'primary'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  }), _c('span', {
    staticClass: "btn-tooltip top",
    staticStyle: {
      "margin-bottom": "-6px"
    }
  }, [_vm._v("Next page")])], 1) : _vm._e()], 2), _vm.card.type == 'INVITATION' ? [_vm.showEventDetails ? _c('v-btn', {
    staticClass: "btn-top ma-0 ml-3",
    staticStyle: {
      "min-width": "unset"
    },
    attrs: {
      "rounded": "",
      "height": "56",
      "color": "primary",
      "aria-label": "RSVP"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click-event-details');
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCalendarEdit)
    }
  }), _c('span', {
    staticClass: "ml-2 mr-1",
    class: {
      'btn-tooltip top': _vm.$vuetify.breakpoint.xsOnly
    }
  }, [_vm._v("Event details…")])], 1) : _vm.mode == 'view' || _vm.mode == 'preview' ? _c('rsvp-btn', {
    staticClass: "btn-top ma-0 ml-3",
    attrs: {
      "pulse": !_vm.didClickRSVP
    },
    on: {
      "click": function ($event) {
        _vm.didClickRSVP = true;
        _vm.$emit('click-rsvp');
      }
    }
  }) : _vm._e()] : _vm._e()], 2) : _vm._e()])]) : _vm._e()]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }